// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"28":"cdda9faa","517":"37744c49","3450":"55b70519","4831":"006a0cbc","6241":"9bb7c1b8","8249":"0dbce49d"}[chunkId] + ".chunk.css";
};